import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';
// Import Data

// import navdata from '../LayoutMenuData';
import useMenuData from '../LayoutMenuData';
//i18n
import { withTranslation } from 'react-i18next';
import withRouter from '../../Components/Common/withRouter';
import { Skeleton } from '../../Components/Common/Skeleton';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const VerticalLayout = props => {
  // const navData = navdata().props.children;
  const { menuItems: navData, isMenuLoading } = useMenuData();
  const path = props.router.location.pathname;

  /*
 layout settings
 */

  const selectLayoutState = state => state.Layout;
  const selectLayoutProperties = createSelector(selectLayoutState, layout => ({
    leftsidbarSizeType: layout.leftsidbarSizeType,
    sidebarVisibilitytype: layout.sidebarVisibilitytype,
    layoutType: layout.layoutType,
  }));
  // Inside your component
  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(
    selectLayoutProperties
  );

  //vertical and semibox resize events
  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize >= 1025) {
      if (document.documentElement.getAttribute('data-layout') === 'vertical') {
        document.documentElement.setAttribute(
          'data-sidebar-size',
          leftsidbarSizeType
        );
      }
      if (document.documentElement.getAttribute('data-layout') === 'semibox') {
        document.documentElement.setAttribute(
          'data-sidebar-size',
          leftsidbarSizeType
        );
      }
      if (
        (sidebarVisibilitytype === 'show' ||
          layoutType === 'vertical' ||
          layoutType === 'twocolumn') &&
        document.querySelector('.hamburger-icon')
      ) {
        //     document.querySelector(".hamburger-icon").classList.remove("open");
        // } else {
        //     document.querySelector(".hamburger-icon").classList.add("open");
        // }
        var hamburgerIcon = document.querySelector('.hamburger-icon');
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove('open');
        }
      } else {
        var hamburgerIcon = document.querySelector('.hamburger-icon');
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add('open');
        }
      }
    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove('twocolumn-panel');
      if (document.documentElement.getAttribute('data-layout') === 'vertical') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (document.documentElement.getAttribute('data-layout') === 'semibox') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (document.querySelector('.hamburger-icon')) {
        document.querySelector('.hamburger-icon').classList.add('open');
      }
    } else if (windowSize <= 767) {
      document.body.classList.remove('vertical-sidebar-enable');
      if (
        document.documentElement.getAttribute('data-layout') !== 'horizontal'
      ) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
      if (document.querySelector('.hamburger-icon')) {
        document.querySelector('.hamburger-icon').classList.add('open');
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener('resize', resizeSidebarMenu, true);
  }, [resizeSidebarMenu]);

  // On phones the sidebar is an overlay drawer: close it once a page is opened
  // instead of leaving it covering the new page.
  useEffect(() => {
    if (document.documentElement.clientWidth <= 767) {
      document.body.classList.remove('vertical-sidebar-enable');
    }
  }, [path]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // keep the current page visible in a long sidebar
    const current = document.querySelector('#navbar-nav a[aria-current]');
    if (current && current.scrollIntoView) {
      current.scrollIntoView({ block: 'nearest' });
    }
  }, [path, navData]);

  const badge = item =>
    item.badgeName ? (
      <span className={'badge badge-pill bg-' + item.badgeColor}>
        {item.badgeName}
      </span>
    ) : null;

  return (
    <React.Fragment>
      {/* menu Items */}
      {isMenuLoading && !(navData || []).length && (
        <li className='nav-item' role='status' aria-busy='true'>
          <span className='visually-hidden'>Loading menu</span>
          {[70, 55, 80, 60, 75, 50].map((width, key) => (
            <div key={key} className='px-4 py-2'>
              <Skeleton width={`${width}%`} height={14} />
            </div>
          ))}
        </li>
      )}
      {(navData || []).map(item => {
        if (item.isHeader) {
          return (
            <li
              key={item.id}
              className={'menu-title' + (item.isActive ? ' is-active' : '')}
            >
              {item.collapsible ? (
                <button
                  type='button'
                  className='menu-title-toggle'
                  onClick={item.toggle}
                  aria-expanded={!item.isCollapsed}
                >
                  <span>{props.t(item.label)}</span>
                  <span
                    className={
                      'menu-title-caret' + (item.isCollapsed ? '' : ' is-open')
                    }
                    aria-hidden='true'
                  ></span>
                </button>
              ) : (
                <div className='menu-title-static'>
                  <span>{props.t(item.label)}</span>
                </div>
              )}
            </li>
          );
        }

        const label = props.t(item.label);
        const itemClass =
          'nav-item' + (item.isGroupCollapsed ? ' nav-group-collapsed' : '');
        const linkClass =
          'nav-link menu-link' +
          (item.isActive || item.hasActive ? ' active' : '');

        if (!item.subItems) {
          return (
            <li key={item.id} className={itemClass}>
              <Link
                className={linkClass}
                to={item.link}
                aria-label={label}
                aria-current={item.isActive ? 'page' : undefined}
              >
                <i className={item.icon} aria-hidden='true'></i>{' '}
                <span>{label}</span>
                {badge(item)}
              </Link>
            </li>
          );
        }

        return (
          <li key={item.id} className={itemClass}>
            <Link
              onClick={item.click}
              className={linkClass}
              to={item.link}
              data-bs-toggle='collapse'
              aria-expanded={!!item.stateVariables}
              aria-controls={`submenu-${item.id}`}
              aria-label={label}
            >
              <i className={item.icon} aria-hidden='true'></i>{' '}
              <span>{label}</span>
              {badge(item)}
            </Link>
            <Collapse
              className='menu-dropdown'
              id={`submenu-${item.id}`}
              isOpen={!!item.stateVariables}
            >
              <ul className='nav nav-sm flex-column'>
                {item.subItems.map(subItem => (
                  <li key={subItem.id} className='nav-item'>
                    <Link
                      to={subItem.link}
                      className={
                        'nav-link' + (subItem.isActive ? ' active' : '')
                      }
                      aria-current={subItem.isActive ? 'page' : undefined}
                    >
                      {props.t(subItem.label)}
                      {badge(subItem)}
                    </Link>
                  </li>
                ))}
              </ul>
            </Collapse>
          </li>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
